module.exports = __webpack_public_path__ + "img/pixing_yj_fubonan.d6fa7bac.jpg";